import { type SpanAttributes, startSpanManual } from '@sentry/core'
import type { MethodDecorator } from './decorators'

/**
 * Decorator for method or class instance - make the method or all method in class bounded
 */
export function span<T, A extends unknown[], R>(
  getAttrs?: NoInfer<(owner: T) => Promise<SpanAttributes>>
): MethodDecorator<T, A, Promise<R>> {
  return (target, { private: isPrivate, name }) => {
    if (isPrivate) throw new TypeError('Not supported on private methods.')
    if (typeof name !== 'string') throw new TypeError('Invalid method name.')
    if (name === 'constructor')
      throw new TypeError('Not supported on constructor.')

    return async function (this: T, ...args: A): Promise<R> {
      const attributes = await getAttrs?.(this)
      const span = startSpanManual({ name, attributes }, s => s)
      try {
        return target.apply(this, args)
      } finally {
        span.end()
      }
    }
  }
}
